import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  LinearProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { saveAsignation } from  "../../../services/FueroTipoElevacionService";
 

const initialState = {
  idFuero: "",
  tipoElevacionList: "",
};

const itemGender = "M";
const nameItemText = "Tipos Elevaciones asignados a los Fueros";

//
// #####################################################################################################################
//
const FueroTipoElevacionDialog = ({
  Fueros,
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [itemTipoElevacionesLocal, setItemTipoElevacionesLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [todosSeleccionados, setTodosSeleccionados] = useState(false);

  const [valueAutoCompleteFueros, setValueAutoCompleteFueros] = useState(
    itemCrud.Fuero
  );
  const [inputValueAutoCompleteFueros, setInputValueAutoCompleteFueros] =
    useState(itemCrud.descripcion_fuero);

  useEffect(() => {
    if (actionCrud === "create") {
      setValueAutoCompleteFueros(Fueros[0]);
      setItemCrudLocal(initialState);
    } else {
      setValueAutoCompleteFueros(itemCrud.descripcion_fuero);
      setItemCrudLocal(itemCrud);
      setItemTipoElevacionesLocal(itemCrud.tipoElevacionList);
    }
  }, []);

  const handleCloseDialog = () => {
    onClose();
  };

  const handleChange = (e) => {
    let itemsTemp = itemTipoElevacionesLocal;
    itemsTemp[e.target.value].asignado = e.target.checked;
    setItemTipoElevacionesLocal([...itemsTemp]);
  };

  const toggleSeleccionTodos = () => {
    let itemsTemp1 = itemTipoElevacionesLocal;
    for (let i = 0; i < itemTipoElevacionesLocal.length; i++) {
      itemsTemp1[i].asignado = !todosSeleccionados;
    }
    setItemTipoElevacionesLocal([...itemsTemp1]);
    setTodosSeleccionados(!todosSeleccionados);
  };

  const handleSave = (e) => {
    if (actionCrud === "create" || actionCrud === "update") {
      if (inputValueAutoCompleteFueros === "") {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar un Fuero",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };

  const save = async () => {
    let localTipoElevacionList = [];

    itemTipoElevacionesLocal.forEach(function (item) {
      if (item.asignado) {
        localTipoElevacionList.push({ id_tipo_elevacion: item.id_tipo_elevacion });
      }
    });

    let _itemCrud = {
      idFuero: itemCrud.idFuero,
      tipoElevacionList: localTipoElevacionList,
      usernameUsuarioActualiza: localStorage.getItem("emailUsuario"),
    };

    setIsDoingSomething(true);
    var actionCrud = "update";
    const response = await saveAsignation(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  const labels = [
    itemCrud.tipoElevacionList.filter((item) => item.habilitado_tipo_elevacion),
  ];

  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
                <DialogTitle id="form-dialog-title"
					textAlign={{ xs: "center", sm: "center" }}			
					 
				>
          {actionCrud === "create"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
            ? "Editando"
            : actionCrud === "enable"
            ? "Habilitando"
            : actionCrud === "disable"
            ? "Deshabilitando"
            : actionCrud === "read"
            ? "Detalle"
            : ""}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {isDoingSomething && <LinearProgress />}
        <DialogContent>
          <DialogContentText style={{ whiteSpace: "pre-wrap" }}>
            Fuero: {itemCrud.descripcionFuero}   {"               "} Habilitado:{" "}
            {itemCrud.habilitadoFuero ? "Sí" : "No"}
          </DialogContentText>
        </DialogContent>
        <DialogContent dividers>
          <Box sx={{ display: "flex" }}>
            <FormControl component="fieldset" variant="standard">
              <FormLabel component="legend">Tipo Elevación asignado</FormLabel>
              <FormGroup sx={{ m: 3 }}>
                <Grid container spacing={1}>
                  <Grid item xs={12} >
                    {(actionCrud !== "read" && itemCrud.habilitadoFuero ) && (<FormControlLabel
                      label="SELECCIONAR TODOS"
                      control={
                        <Checkbox
                        position='rigth'
                          checked={todosSeleccionados}
                          onChange={toggleSeleccionTodos}
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                          name="seleccionarTodos"
                        />
                      }
                    />
                    )}
                  </Grid>
                  {labels[0].map((item, index) => (
                    <Grid item xs={12} key={item.id_tipo_elevacion}>
                      <FormControlLabel
                          disabled={actionCrud === "read" || !item.habilitado_tipo_elevacion || ! itemCrud.habilitadoFuero }
                          control={
                          <Checkbox
                            checked={item.asignado}
                            disabled={!item.habilitado_tipo_elevacion}
                            onChange={handleChange}
                            key={item.id_tipo_elevacion}
                            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                            name="asignado"
                            id={item.id_tipo_elevacion}
                            value={index}
                            inputProps={{
                              "aria-label": "Checkbox A",
                            }}
                          />
                        }
                        label={item.descripcion_tipo_elevacion}
                      />
                    </Grid>
                  ))}
                </Grid>
              </FormGroup>
            </FormControl>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              onClick={handleCloseDialog}
							startIcon={<CloseIcon />}
						>						
             Cancelar 
            </Button>

            {actionCrud !== "read" && (
              <Button
                sx={{ backgroundcolor: "warning" }}
                variant="contained"
                onClick={handleSave}
                startIcon={
                  actionCrud === "disable" ? (
                    <RemoveCircleOutlineIcon />
                  ) : actionCrud === "enable" ? (
                    <AddCircleOutlineIcon />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {actionCrud === "disable"
                  ? "Deshabilitar"
                  : actionCrud === "enable"
                  ? "Habilitar"
                  : "Guardar"}
              </Button>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FueroTipoElevacionDialog;
